<template>
  <div class="mc-liveview__map">
    <GmapMap
      id="map"
      ref="MapMonitoring"
      :center="center"
      :zoom="zoom"
      :options="gMapOptions"
      class="mc-map mc-map--route"
      >]
      <gmap-custom-marker
        v-if="marker.vehicle.lat && marker.vehicle.lng && statusMarker.actual"
        :marker="{
          lat: Number(marker.vehicle.lat),
          lng: Number(marker.vehicle.lng),
        }"
        :offsetY="40"
      >
        <div class="text-center">
          <img
            :src="
              require(`@/assets/images/vehicles/${marker.vehicle.icon}/${marker.vehicle.icon}-dark-grey.png`)
            "
            :style="`transform: rotate(${marker.vehicle.direction}deg);`"
            :alt="`mceasy-lifeview-${marker.vehicle.icon}-icon`"
          />
        </div>
      </gmap-custom-marker>

      <template v-if="statusMarker.primary">
        <gmap-custom-marker
          v-for="(row, index) in primaryLoc"
          :key="`primary-${index}`"
          :marker="{
            lat: Number(row.lat),
            lng: Number(row.lng),
          }"
          :offsetY="40"
        >
          <div v-if="primaryLoc" class="text-center mc-map--route-marker">
            <img alt="marker" src="@/assets/images/caricon/primary-loc.svg" />
            <span>{{ index + 1 }}</span>
          </div>
        </gmap-custom-marker>
      </template>

      <template v-if="alternateLoc.length && statusMarker.alternative">
        <gmap-custom-marker
          v-for="(row, index) in alternateLoc"
          :key="`alternative-${index}`"
          :marker="{
            lat: Number(row.lat),
            lng: Number(row.lng),
          }"
          :offsetY="60"
        >
          <div v-if="alternateLoc" class="text-center mc-map--route-marker">
            <img alt="marker" src="@/assets/images/caricon/alt-loc.svg" />
            <span>{{ index + 1 }}</span>
          </div>
        </gmap-custom-marker>
      </template>
    </GmapMap>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import responsive from '@/mixin/responsive'
import * as routeApi from '@/services/rest-api-vsms/lib/route/route'
import { gmapApi } from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import { GET_RAW_LOCATION } from '@/services/api/fleet'
import { GET_VEHICLE_ID } from '@/services/api/master/fleet'

export default {
  name: 'GMapPlaning',
  components: {
    'gmap-custom-marker': GmapCustomMarker,
  },
  mixins: [Helper, responsive],
  props: {
    geometry: Object,
    radio: Object,
  },
  data() {
    return {
      routeApi: routeApi,

      map: null,
      gMapOptions: {},
      center: { lat: -2.958881, lng: 109.5543666 },
      zoom: 5.56,
      directionsService: null,
      directionsRenderer: null,
      allPathPrimary: [],
      allPathSecondary: [],
      allPathActual: [],
      primaryLoc: [],
      alternateLoc: [],
      marker: {
        vehicle: {
          lat: 0,
          lng: 0,
          direction: 0,
          icon: null,
        },
      },

      statusMarker: {
        primary: true,
        alternative: true,
        actual: true,
      },

      geoData: {},
      priority: 0,
      loading: false,
    }
  },

  computed: {
    google: gmapApi,
  },

  watch: {
    radio: {
      handler(val) {
        this.statusMarker = val
        if (this.map) {
          if (val.primary) {
            this.allPathPrimary.forEach((element) => {
              element.setMap(this.map)
            })
          } else {
            this.allPathPrimary.forEach((element) => {
              element.setMap(null)
            })
          }

          if (val.alternative) {
            this.allPathSecondary.forEach((element) => {
              element.setMap(this.map)
            })
          } else {
            this.allPathSecondary.forEach((element) => {
              element.setMap(null)
            })
          }

          if (val.actual) {
            this.allPathActual.forEach((element) => {
              element.setMap(this.map)
            })
          } else {
            this.allPathActual.forEach((element) => {
              element.setMap(null)
            })
          }
        }
      },
      deep: true,
      immediate: true,
    },
    geometry: {
      async handler(val, oldValue) {
        if (val?.id) {
          if (JSON.stringify(oldValue) != '{}') {
            const getDifference = (a, b) =>
              Object.fromEntries(
                Object.entries(b).filter(([key, val]) => key in a && a[key] !== val)
              )
            if (JSON.stringify(getDifference(oldValue, val)) === '{}') {
              return
            }
          }

          this.primaryLoc.splice(0, this.primaryLoc.length)
          this.alternateLoc.splice(0, this.alternateLoc.length)
          await this.resetPolyline()

          if (val.startOn) {
            this.getRawLocation()
          }

          let params = null
          if (
            val.status == 'progress' ||
            val.status == 'done' ||
            (val.status == 'cancelled' && val.startOn != '' && val.startOn != null)
          )
            params = {
              source: 'archived',
              limit: val.startOn,
            }

          this.priority = 0
          this.geoData = await routeApi.showDirection(val.id, params)
          this.generateLine(this.geoData)

          val.route_plan.forEach((row, index) => {
            row.geofences.forEach((geo) => {
              if (geo.type === 'C') {
                const circle = geo.coordinates.split(',')
                const latLng = {
                  lat: Number(circle[0].replace('<(', '')),
                  lng: Number(circle[1].replace(')', '')),
                }

                if (index === 0) {
                  this.primaryLoc.push(latLng)
                } else {
                  this.alternateLoc.push(latLng)
                }
              } else if (geo.type === 'P') {
                const poly = geo.coordinates.split('),(')
                const bounds = new this.google.maps.LatLngBounds()
                poly.forEach((element) => {
                  const latlng = element.split(',')
                  bounds.extend({
                    lat: Number(latlng[0].replace('((', '')),
                    lng: Number(latlng[1].replace('))', '')),
                  })
                })
                const latLng = {
                  lat: bounds.getCenter().lat(),
                  lng: bounds.getCenter().lng(),
                }

                if (index === 0) {
                  this.primaryLoc.push(latLng)
                } else {
                  this.alternateLoc.push(latLng)
                }
              }
            })
          })

          await this.$nextTick()
          if (!val.startOn) {
            this.fitBounds()
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    const self = this

    await this.$refs.MapMonitoring.$mapPromise.then((map) => {
      let directionsService = new this.google.maps.DirectionsService()
      let directionsRenderer = new this.google.maps.DirectionsRenderer({
        suppressMarkers: false,
      })
      self.map = map

      this.directionsService = directionsService
      this.directionsRenderer = directionsRenderer

      self.gMapOptions = {
        minZoom: 3,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        scaleControl: true,
        streetViewControl: true,
        streetViewControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        fullscreenControl: false,
      }
    })
  },

  methods: {
    async getRawLocation() {
      const endOn = this.geometry.endOn ? this.geometry.endOn : this.now()

      const res = await this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: GET_RAW_LOCATION,
        variables: {
          filter: {
            startDate: this.geometry.startOn,
            endDate: endOn,
            vehicleId: this.geometry.vehicle.id,
          },
        },
      })

      const vehicle = await this.$apollo.query({
        fetchPolicy: 'no-cache',
        query: GET_VEHICLE_ID,
        variables: {
          filter: {
            id: this.geometry.vehicle.id,
          },
        },
      })

      if (res.data.rawLocations.isSuccessful) {
        const rawLocations = res.data.rawLocations.rawLocations
        if (!rawLocations.length) {
          this.fitBounds()
          return
        }

        this.marker.vehicle = {
          lat: rawLocations.at(-1).latitude,
          lng: rawLocations.at(-1).longitude,
          direction: rawLocations.at(-1).direction,
          icon: vehicle.data.vehicle.vehicle?.vehicleType?.icon,
        }

        const actualLines = []
        for (let i = 0; i < rawLocations.length - 1; i++) {
          actualLines.push(
            new this.google.maps.LatLng(rawLocations[i].latitude, rawLocations[i].longitude)
          )
          actualLines.push(
            new this.google.maps.LatLng(rawLocations[i + 1].latitude, rawLocations[i + 1].longitude)
          )
        }

        // create a polyline
        let actualPath = new this.google.maps.Polyline({
          path: actualLines,
          geodesic: true,
          strokeOpacity: 1.0,
          strokeWeight: 8,
        })

        this.allPathActual.push(actualPath)
        // set the color of the segment based on the lowest index point

        actualPath.setOptions({
          strokeColor: '#FF8A00',
        })

        actualPath.setMap(this.map)

        this.fitBounds()
      }
    },

    async generateLine({ data }) {
      this.loading = true
      await this.resetPolyline()

      const generalRoute = JSON.parse(data.route_plan[0].geometry)
      const alternativeRoute =
        data.route_plan.length > 1 ? JSON.parse(data.route_plan[1].geometry) : []

      this.createLine(generalRoute, alternativeRoute)
    },

    createLine(primaryRoute, secondaryRoute) {
      const primarylines = []
      for (let i = 0; i < primaryRoute.length - 1; i++) {
        primarylines.push(new this.google.maps.LatLng(primaryRoute[i][1], primaryRoute[i][0]))
        primarylines.push(
          new this.google.maps.LatLng(primaryRoute[i + 1][1], primaryRoute[i + 1][0])
        )
      }

      // create a polyline
      let primaryPath = new this.google.maps.Polyline({
        path: primarylines,
        geodesic: true,
        strokeOpacity: 1.0,
        strokeWeight: 8,
      })

      this.allPathPrimary.push(primaryPath)
      // set the color of the segment based on the lowest index point

      primaryPath.setOptions({
        strokeColor: '#0D4491',
        zIndex: 99999,
      })

      primaryPath.setMap(this.map)

      if (secondaryRoute?.length) {
        const secondarylines = []
        for (let i = 0; i < secondaryRoute.length - 1; i++) {
          secondarylines.push(
            new this.google.maps.LatLng(secondaryRoute[i][1], secondaryRoute[i][0])
          )
          secondarylines.push(
            new this.google.maps.LatLng(secondaryRoute[i + 1][1], secondaryRoute[i + 1][0])
          )
        }
        // create a polyline
        let secondaryPath = new this.google.maps.Polyline({
          path: secondarylines,
          geodesic: true,
          strokeOpacity: 1.0,
          strokeWeight: 8,
        })

        this.allPathSecondary.push(secondaryPath)
        // set the color of the segment based on the lowest index point

        secondaryPath.setOptions({
          strokeColor: '#72A8E9',
          zIndex: 9999,
        })

        secondaryPath.setMap(this.map)
      }

      this.loading = true
    },

    fitBounds() {
      if (!this.allPathPrimary.length) return this.fitBounds()
      let bounds = new this.google.maps.LatLngBounds()
      this.allPathPrimary.forEach((p) => {
        p.getPath().forEach((LatLng) => {
          bounds.extend(LatLng)
        })
      })

      this.allPathSecondary.forEach((s) => {
        s.getPath().forEach((LatLng) => {
          bounds.extend(LatLng)
        })
      })

      this.allPathActual.forEach((a) => {
        a.getPath().forEach((LatLng) => {
          bounds.extend(LatLng)
        })
      })

      this.map.fitBounds(bounds)
    },

    resetPolyline() {
      this.allPathPrimary.forEach((element) => {
        element.setMap(null)
      })
      this.allPathSecondary.forEach((element) => {
        element.setMap(null)
      })
      this.allPathActual.forEach((element) => {
        element.setMap(null)
      })

      this.primaryLoc.splice(0, this.primaryLoc.length)
      this.alternateLoc.splice(0, this.alternateLoc.length)

      this.allPathPrimary.splice(0, this.allPathPrimary.length)
      this.allPathSecondary.splice(0, this.allPathSecondary.length)
      this.allPathActual.splice(0, this.allPathActual.length)

      this.marker = {
        vehicle: {
          lat: 0,
          lng: 0,
          direction: 0,
          icon: null,
        },
      }
    },
  },
}
</script>
